import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DwConfigService, DwConfigServiceToken } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';

import {
  AddAssignmentStudentsRequest,
  AddAssignmentStudentsResult,
  AssignmentStudentSelectionContext
} from '../models/assignment-student-management.model';

@Injectable({ providedIn: 'root' })
export class AssignmentStudentManagementService {
  private readonly apiUrl: string;

  constructor(
    @Inject(DwConfigServiceToken) configService: DwConfigService,
    private http: HttpClient
  ) {
    this.apiUrl = `${configService.coreConfig.apiRoot}/aviator-online/students/assignments`;
  }

  getSelectionContext(assignmentId: number): Observable<AssignmentStudentSelectionContext> {
    return this.http.get<AssignmentStudentSelectionContext>(
      `${this.apiUrl}/${assignmentId}/student-selection-context`);
  }

  addStudents(assignmentId: number, studentIds: number[]): Observable<AddAssignmentStudentsResult> {
    const request: AddAssignmentStudentsRequest = { StudentIds: studentIds };
    return this.http.post<AddAssignmentStudentsResult>(`${this.apiUrl}/${assignmentId}/students`, request);
  }

  isInstructorAvailableForSchool(instructorId: number, flightSchoolId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.apiUrl}/instructors/${instructorId}/schools/${flightSchoolId}/available`);
  }
}
